/***
 * it should add a background-image css to an div or img html
 *
 * the staticUrl should be set on the config file, it probably is a s3 bucket.
 */
import { Directive, ElementRef, Inject, Input, Renderer2 } from '@angular/core'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'

@Directive({
  selector: '[s3File]',
})
export class S3FileDirective {
  @Input('s3File') image: any

  constructor(private elmRef: ElementRef, private renderer: Renderer2, @Inject(APP_CONFIG) private appConfig: any) {}

  ngOnInit() {
    const htmlItemType = this.elmRef.nativeElement.localName
    const el = this.elmRef.nativeElement
    const imgSrc = this.appConfig.staticUrl + this.image
    if (htmlItemType === 'div') {
      this.renderer.setStyle(el, 'background-image', `url(${imgSrc})`)
    } else {
      this.elmRef.nativeElement.src = imgSrc
    }
  }
}
